export const PAGE_IDS = {
  ACCESSORIAL_REVENUE_INSIGHTS: "accessorial_revenue_insights",
  ACCESSORIAL_REVIEW_DASHBOARD: "accessorial_review_dashboard",
  ACTIVE_ROUTES: "active-routes",
  ADDRESSMANAGER: "address-manager",
  AGENTS: "agents",
  AGING_INVOICES_120_PLUS: "aging-invoices_120_PLUS",
  AGING_INVOICES_1_30: "aging-invoices_1_30",
  AGING_INVOICES_31_60: "aging-invoices_31_60",
  AGING_INVOICES_61_90: "aging-invoices_61_90",
  AGING_INVOICES_91_120: "aging-invoices_91_120",
  AGING_INVOICES_TOTAL: "aging-invoices_TOTAL",
  AI: "ai-chat",
  EOD_REPORT: "eod-report",
  EQUIPMENT: "equipment",
  ANNOUNCEMENT: "announcement",
  RELEASE_DETAILS: "release-details",
  APPOINTMENTS: "appointments",
  BOL: "bol",
  BILLING_REVIEW: "billing-review",
  CLAIMS: "claims",
  CREATE_PICKUP: "create-pickup",
  CREATE_QUICK_PICKUP: "create_quick_pickup",
  CARRIERS: "carriers",
  CUSTOMERS: "customers",
  DASHBOARD: "dashboard",
  DISPATCH_BOARD: "dispatch-board",
  DRIVERLIST: "driver-list",
  DOCK_AUTH_AUDIT: "dock-auth-audit",
  DOCK_LOADING: "dock-loading",
  DOCK_SCAN_LOGS: "dock-scan-logs",
  DOCK_USERS: "dock-users",
  DOCUMENTS: "shipments-documents",
  EMERGENCY_ALERT_MANAGEMENT: "emergency-alert",
  FEATURE_BANNER: "feature-banner",
  PAYMENT_SETTINGS: "payment-settings",
  PAYMENT_HISTORY: "payment-history",
  PAYMENT_ADMIN: "payment-admin",
  PUBLIC_PAYMENT_LINKS: "public-payment-links",
  HOLIDAYS: "holidays",
  RPG_ANALYZER: "rpg-analyzer",
  IMAGES: "images",
  LABELS_RECEIPTS: "shipments-labels-receipts",
  LANE_MANAGEMENT: "lane-management",
  LINEHAUL_MILEAGE: "linehaul-mileage",
  LINEHAUL_OUTBOUND_PLANNING: "linehaul-outbound-planning",
  LOADBOARD_DISPATCH: "loadboard-dispatch",
  MANIFEST_DOCUMENTS: "manifest-documents",
  OPERATIONS_REVIEW: "operations-review",
  PENDING_REQUESTS: "pending-requests",
  PICKLISTS: "picklists",
  PICKUP_ASSIGNMENT: "pickup-assignment",
  PICKUP_ASSIGNMENT_V2: "pickup-assignment-v2",
  PICKUP_INBOX: "pickup-inbox",
  PICKUP_INBOX_ANALYTICS: "pickup-inbox-analytics",
  PICKUP_LOG: "pickup-log",
  PICKUP_SUMMARY: "pickup-summary",
  PICKUPS: "pickups",
  PLAN_ROUTE: "plan-route",
  POD_RECOGNITION: "pod-recognition",
  RATE_QUOTES: "rate-quotes",
  RECOGNITION_LOGS: "recognition_logs",
  REPORTS_SCHEDULED: "reports-scheduled",
  REQUEST_PICKUP: "request_pickup",
  RETURNS: "returns",
  ROUTE_GUIDE: "route-guide",
  SERVICE_DISRUPTION: "service-disruption",
  TERMINAL_INSIGHTS: "terminal-insights",
  TRACK_MANIFESTS: "track-manifests",
  TRACK_SHIPMENTS: "shipments-track-shipments",
  TERMINAL_SUMMARY: "terminal-summary",
  TRANSIT_CALCULATOR: "transit-calculator",
  UNPLANNABLE_PROBILLS: "unplannable-probills",
  USERS: "users",
  WAREHOUSE_INVENTORY: "warehouse-inventory",
  WAREHOUSE_SUMMARY: "warehouse-summary",
  // please add new lines in alphabetical order
};